<template>
 <div>
  <ul class="f-layout ChilMenu" :class="'ul' + level">
      <li v-for="item in listData" :key="item.value" :class="'level' + item.level">
          <a
            class="mb--10 single-area-a"
            :class="currentParentIdArr.includes(item.value) ? 'theme-color' : ''"
            :href="getCompleteHref(item.value)"
            :title="`${item.text}${keyword}招标信息-千里马招标网`"

            >{{ item.text }}</a
          >     
      </li>
    </ul>
    <ChilMenu
           v-if="childrenList.value"
          :currentObj="childrenList"
          :level="level+1"
          :pageType="pageType"
          :current-parent-id-arr="currentParentIdArr"
        ></ChilMenu>
 </div>
</template>

<script>
import ChilMenu from "@/components/Hot/ChilMenu"

export default {
  name: "ChilMenu",
  props: {
    level: {
      type: Number,
      default: () => 1,
    },
    currentParentIdArr: {
      type: Array,
      default: () => [],
    },
    currentObj:{
      type: Object,
      default: () => {},
    },
    pageType: {
      type: String,
      default: () => "",
    },
    keyword: {
      type: String,
      default: () => "",
    },
  },
  data(){
    return{
      listData:[]
    }
  },
  computed: {
    publicResource() {
      return this.$store.getters["hot/otherObj"];
    },
    childrenList(){
      let list ={}
      list =this.listData.find(item=> this.currentParentIdArr.includes(item.value))||{}
      return list
      
    }
  },
  mounted() {
    this.listData=this.currentObj.children||[];
  },
  methods: {
    getCompleteHref(val) {
      const { typeId, wId } = this.publicResource;
      const pageType = this.pageType;
      const typeStr = typeId ? "_" + typeId : "";
     
      let href = "";
      switch (pageType) {
        case "hot":
          href = `/hot${wId}${val}/`;
          break;
        case "gjxx":
          href = `/gjxx/${wId}_${val}${typeStr}`;
          break;
      }
      return href;
    },
  },
};
</script>

<style lang="scss">
.ChilMenu{
  flex-wrap: wrap;
 & .ul1 {
    position: relative;
    flex-wrap: wrap;
  }
}
 

  // .ul2 {
  //   position: absolute;
  //   left: 0;
  //   top: 26px;
  //   flex-wrap: wrap;
  // }
</style>
